<template>
  <div>
    <div class="searchDiv">
      <el-input class="searchInput" v-model="params.name" placeholder="请输入流程名称" clearable @clear="getPageList"
                @keyup.enter.native="getPageList"/>
      <el-button type="primary" @click="getPageList">查询</el-button>
      <el-button v-if="hasPer('flow:add')" @click="editRow" style="float: right;">新增</el-button>
    </div>
    <el-table :data="tableData" row-key="id" border>
      <el-table-column label="流程名称" prop="name" width="250px"></el-table-column>
      <el-table-column label="流程描述" prop="description"></el-table-column>
      <el-table-column label="操作" prop="option" width="220px" align="center">
        <template slot-scope="scope">
          <el-button v-if="hasPer('flow:edit')" type="primary" @click="editRow(JSON.parse(JSON.stringify(scope.row)))">
            编辑
          </el-button>
          <el-button v-if="hasPer('flow:design')" type="success"
                     @click="designFlow(JSON.parse(JSON.stringify(scope.row)))">设计
          </el-button>
          <el-button v-if="hasPer('flow:del')" type="danger" @click="delRow(scope.row.id, scope.row.name)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <pagination :current.sync="current" :size.sync="size" :total="total" @get-list="getPageList"></pagination>
    <edit-flow :dialog-visible.sync="dialogVisible" :data-obj="rowDataObj" @get-list="getPageList"></edit-flow>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import {delFlow, getFlowList} from "@/api/sys/flow/flow";
import {infoMsg, successMsg} from "@/utils/message";
import {hasPer} from "@/utils/common";
import store from "@/store";
import EditFlow from "@/views/approval/flow/editFlow.vue";
import routers from "@/router/routers";

export default {
  name: "flow",
  components: {
    EditFlow,
    Pagination
  },
  data() {
    return {
      params: {
        name: ''
      },
      username: store.state.userInfo.username,
      tableData: [],
      dialogVisible: false,
      rowDataObj: {},
      current: 1,
      size: 10,
      total: 0
    }
  },
  mounted() {
    this.getPageList();
  },
  methods: {
    hasPer,
    getPageList() {
      getFlowList({...this.params}).then(res => {
        this.tableData = res.records
        this.total = res.total
      })
    },
    editRow(row) {
      this.dialogVisible = true
      this.rowDataObj = row.id ? row : {}
    },
    delRow(id, username) {
      this.$confirm('确定删除流程【' + username + '】？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delFlow(id).then(() => {
          successMsg('操作成功')
          this.getPageList()
        })
      }).catch(() => {
        infoMsg('操作已取消')
      })
    },
    designFlow(row) {
      //  将当前打开的菜单添加到已打开列表中
      store.dispatch('addTabAction', {name: "流程设计", path: `/flow/design`, params: {id: row.id}})
      //  将激活菜单改成选中的菜单
      store.dispatch('activeIndexAction', "流程设计")
      routers.push({name: "流程设计", params: {id: row.id}})
    },
    buttonType(type) {
      if (type) {
        return 'warning'
      } else {
        return 'success'
      }
    }
  }
}
</script>

<style scoped>

</style>
